import React from "react";
import { getStrategyColor } from "./strategyColors.js";
import ContractLink from "./ContractLink.jsx";

const MAX_BETS = 20

export default function BettingTable({ bets }) {
  if (!bets || bets.length === 0) {
    return (
      <div className="betting-table-section">
        <h3>Recent Bets</h3>
        <div className="no-data">No betting data available</div>
      </div>
    );
  }

  // Sort bets by timestamp (most recent first)
  const sortedBets = [...bets].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)).slice(null, MAX_BETS);

  return (
    <div className="betting-table-section">
      <h3>Recent Bets</h3>
      <div
        className="table-container"
        style={{ maxHeight: '400px', overflowY: 'auto', overflowX: 'auto' }}
      >
        <table className="betting-table">
          <thead>
            <tr>
              <th>Time</th>
              <th>Strategy</th>
              <th>Outcome</th>
              <th>Limit Prob</th>
              <th>Amount</th>
              <th>Filled</th>
              <th>Contract ID</th>
              <th>Answer ID</th>
              <th>Time to Bet</th>
            </tr>
          </thead>
          <tbody>
              {sortedBets.map((bet, index) => (
                <tr key={`${bet.contract_id}-${index}`}>
                  <td title={bet.timestamp ? bet.timestamp.toLocaleString() : 'N/A'}>
                    {bet.timestamp ? (
                      <>
                        {new Date(bet.timestamp).toLocaleDateString()} {new Date(bet.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                      </>
                    ) : 'N/A'}
                  </td>
                  <td>
                    <span
                      className="strategy-badge"
                      style={{ backgroundColor: getStrategyColor(bet.strategy) }}
                    >
                      {bet.strategy || 'N/A'}
                    </span>
                  </td>
                <td>
                  <span className={`outcome-badge outcome-${bet.outcome ? bet.outcome.toLowerCase() : 'unknown'}`}>
                    {bet.outcome || 'N/A'}
                  </span>
                </td>
                <td>{bet.limit_prob ? (bet.limit_prob * 100).toFixed(1) + '%' : '-'}</td>
                <td>{bet.amount || 'N/A'}</td>
                <td>{bet.filled_amount != null ? bet.filled_amount.toFixed(2) : '0'}</td>
                <td>
                  <ContractLink contractId={bet.contract_id} />
                </td>
                <td>{bet.answer_id || '-'}</td>
                <td>{bet.ms_to_bet != null ? `${bet.ms_to_bet.toFixed(0)}ms` : '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}


